<template>
  <div>
    <b-form
      inline
      class="mb-2"
    >
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="d-inline-block mr-1 mb-1"
        @click="createNew"
      >
        {{ $t('Add') }}

      </b-button>

      <b-form-input
        v-model="searchTerm"
        :placeholder="$t('message.SearchPlaceholder')"
        type="text"
        class="d-inline mb-1"
      />

      <b-link
        class="ml-2"
        @click="downloadCurrent"
      >
        Download Report Configs
      </b-link>

      <b-dropdown
        v-if="selectedRecords.length>0"
        id="dropdown-actions"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :text="$t('Actions')"
        variant="primary"
        class="ml-1 mb-1"
      >
        <b-dropdown-item
          variant="danger"
          @click="confirmDelete"
        >
          <feather-icon
            icon="Trash2Icon"
          />
          {{ $t('Delete') }}

        </b-dropdown-item>
      </b-dropdown>

    </b-form>

    <!-- table -->
    <vue-good-table
      style-class="vgt-table striped"
      :columns="columns"
      :rows="data"
      :sort-options="{
        enabled: true,
        initialSortBy: {field: 'id', type: 'desc'}
      }"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength,
        mode: 'records',
        perPage: 10,
        perPageDropdown: [10, 50, 100],
        dropdownAllowAll: false,
      }"
      @on-selected-rows-change="selectedRowsChanged"
    >

      <template
        slot="table-column"
        slot-scope="props"
      >
        <span>
          {{ $t(props.column.label) }}
        </span>
      </template>

      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: id -->
        <span
          v-if="props.column.field === 'id'"
          class="text-nowrap"
        >
          <b-link @click="edit(props.row)">
            <feather-icon
              icon="EditIcon"
            />

          </b-link>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

    </vue-good-table>

    <b-modal
      id="add-item-report-config"
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      :title="$t('Add Item')"
      :ok-title="$t('OK')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <form-report-config
        ref="form-report-config"
        v-model="edit_item"
        :project-id="projectId"
        @submit="getReportConfigs"
      />
    </b-modal>

  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BLink, BFormInput, BForm, BButton, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueGoodTable } from 'vue-good-table'
import FormReportConfig from '@/layouts/components/forms/FormReportConfig.vue'

export default {
  components: {
    FormReportConfig,
    VueGoodTable,
    BLink,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      data: [],
      columns: [
        {
          label: '#',
          field: 'id',
          type: 'number',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '50px',
        },
        {
          label: 'Project Name',
          field: 'projectName',
        },
        {
          label: 'Report Title',
          field: 'reportTitle',
        },
        {
          label: 'Part',
          field: 'part',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '130px',
          type: 'number',
        },
        {
          label: 'BreakBy',
          field: 'breakByQuestionName',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'Weight',
          field: 'weightColumn',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'Loop',
          field: 'loopColumn',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'Sort Order',
          field: 'sortOrder',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '130px',
          type: 'number',
        },
      ],
      pageLength: 10,
      searchTerm: '',
      selectedRecords: [],
      edit_item: null,
    }
  },
  created() {
    this.getReportConfigs()
  },
  methods: {
    openFile(response, filename) {
      const blob = new Blob([`\ufeff${response.data}`], {
        type: 'text/csv; charset=utf-8',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      link.remove()
    },
    downloadCurrent() {
      useJwt.axiosIns.get('report/downloadCurrentConfigs', { params: { projectId: this.projectId } })
        .then(response => {
          if (response.data) {
            this.openFile(response, `reportConfig_${this.projectId}.csv`)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getReportConfigs() {
      this.$bvModal.hide('add-item-report-config')
      useJwt.axiosIns.get(`report/${this.projectId}`)
        .then(response => {
          if (response.data) {
            this.data = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    edit(item) {
      this.edit_item = JSON.parse(JSON.stringify(item))
      this.$bvModal.show('add-item-report-config')
    },
    createNew() {
      this.$bvModal.show('add-item-report-config')
    },
    selectedRowsChanged(vals) {
      this.selectedRecords = vals.selectedRows.map(x => x.id)
    },

    confirmDelete() {
      this.$swal({
        title: 'Are you sure?',
        text: `You are about to delete ${this.selectedRecords.length} record(s)...`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteSelectedRecords()
        }
      })
    },

    deleteSelectedRecords() {
      const promises = this.selectedRecords.map(x => useJwt.axiosIns.delete(
        `report/${x}`,
      ))

      Promise.all(promises).then(() => {
        this.getReportConfigs()
        // show message
        this.$swal({
          icon: 'success',
          title: 'Deleted!',
          text: `${this.selectedRecords.length} record(s) has been deleted.`,
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.$refs['form-report-config'].validationForm()
    },
    handleCancel() {
      this.edit_item = null
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
